import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import ListaGruposPage from './components/ListaGruposPage';
import LoginPage from './components/LoginPage';
import LogoBorder from './components/LogoBorder';
import logorock from './assets/images/rockstar_logo.png';
import Footer from './components/Footer';



function App() {
  return (
    <Router>
      <div>
        <LogoBorder logoUrl={logorock} logoSize={30} gap={5} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/grupos" element={<ListaGruposPage />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </div>
      <Footer/>
    </Router>
  );
}

export default App;
